export default __webpack_public_path__ + "static/media/Interacting2.1fb3186f.png";